<div class="image-view-container">
  <div class="img-container fade" #container [style.min-height]="skeletonHeight + 'px'">
    @if (item){
      <p class="no-data">{{ item.message }}</p>

      @if (!item.image) {
        <div class="image">
          <img
            ngSrc="../../../../../assets-common/default/logo_error_icon.svg"
            alt="" height="64" width="64"/>
        </div>
      } @else {
        @if (getImage() | async; as image) {
          <div class="image">
            <img  [src]="image" [alt]="image" />
          </div>
        } @else {
          <app-skeleton [style.height]="skeletonHeight + 'px'"></app-skeleton>
        }
      }
    } @else {
<!--      NO ITEM-->
    }
  </div>

  <div class="paginator">
    @for (i of Array.from(Array(itemsCount).keys()); track i){
      <div class="dot" (click)="index=i" (keydown.enter)="index=i" (keydown.space)="index=i" [class.selected]="i===index" tabindex="0"></div>
    }

  </div>

  <div class="image-buttons">
    <button [disabled]="cantMove()" mat-icon-button (click)="prev()" aria-label="Previous image">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <button [disabled]="cantMove()" mat-icon-button (click)="next()" aria-label="Next image">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
